import { render, staticRenderFns } from "./BTCWallet.vue?vue&type=template&id=79d66b9c&scoped=true&"
import script from "./BTCWallet.vue?vue&type=script&lang=js&"
export * from "./BTCWallet.vue?vue&type=script&lang=js&"
import style0 from "./BTCWallet.vue?vue&type=style&index=0&id=79d66b9c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79d66b9c",
  null
  
)

export default component.exports